export default {
  ErrorKMS: 'ErrorKMS',
  Error: 'Error',
  Success: 'Success',
};
